
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    label: String,
    id: String,
    autocomplete: String,
    modelValue: {
      required: true,
      type: [String, Number]
    }
  },
  computed: {
    input: {
      get(): string | number {
        return this.modelValue;
      },
      set(value: string | number) {
        this.$emit("update:modelValue", value);
      }
    }
  }
});
